import React, { Component } from "react";
import { DatePicker } from "/src/component/general/DatePicker";
import Alert from "react-s-alert";

import EntityDropdown from "../../component/EntityDropdown";
import { ABSENCE_USER } from "../../config/lang";

import { call } from "../../util/action";
import { dateStart, dateEnd } from "../../util/formatter";
import { getStore } from "../../util/redux/store";
import { translate } from "../../util/util";

const me = getStore().getState().me;

class Absence extends Component {
  constructor(props) {
    super(props);

    this.state = {
      item: {
        start: new Date(),
        end: new Date(),
        reason: "",
      },
      changedItem: false,
      items: [],
    };
  }

  submit = () => {
    let { item } = this.state;

    item.created_by = me.id;
    item.merchandiser = this.props.user.id;
    setTimeout(() => {
      call({ method: "POST", url: "absences/", post: item }, r => {
        if (r && r.id) {
          Alert.success("Дані успішно збережені", { position: "bottom-right" });
          let cleanItem = { reason: "", start: new Date(), end: new Date() };
          this.setState({ item: cleanItem });
          this.load();
        } else {
          Alert.warning("Error while saving item. Error: " + JSON.stringify(r), { position: "bottom-right" });
        }
      });
    }, 3000);

    this.setState({ changedItem: true });
  };

  onChange = (property, value) => {
    let item = this.state.item;
    item[property] = value;
    this.setState({ item: item, changedItem: false });
  };

  componentDidMount() {
    this.load();
  }

  load = () => {
    call({ method: "GET", url: "absences?merchandiser=" + this.props.user.id }, r => {
      this.setState({ items: r });
    });
  };

  render() {
    let { item } = this.state;
    return (
      <div className="mp-absence">
        <div className="mp-absence-form-card">
          <h3 className="mp-absence-title">{translate(ABSENCE_USER, "query", me.language)}</h3>

          <div className="mp-absence-form-grid">
            <div className="mp-form-group">
              <label className="mp-form-label">{translate(ABSENCE_USER, "date_from", me.language)} *</label>
              <DatePicker selected={new Date(item.start)} className="mp-form-input" onChange={date => this.onChange("start", date)} />
            </div>

            <div className="mp-form-group">
              <label className="mp-form-label">{translate(ABSENCE_USER, "date_to", me.language)} *</label>
              <DatePicker selected={new Date(item.end)} className="mp-form-input" onChange={date => this.onChange("end", date)} />
            </div>
          </div>

          <div className="mp-form-group">
            <label className="mp-form-label">{translate(ABSENCE_USER, "reason", me.language)} *</label>
            <input
              type="text"
              className="mp-form-input"
              placeholder={translate(ABSENCE_USER, "absence_reason", me.language)}
              value={item.reason}
              onChange={e => this.onChange("reason", e.target.value)}
            />
          </div>

          <div className="mp-form-group">
            <label className="mp-form-label">{translate(ABSENCE_USER, "absence_short_reason_title", me.language)}</label>
            <EntityDropdown
              entity="absence_reason_templates"
              placeholder={translate(ABSENCE_USER, "absence_short_reason", me.language)}
              value={item.reason}
              onChange={e => {
                this.onChange("reason", e.label);
              }}
            />
          </div>

          <div className="mp-absence-form-actions">
            <button className={`mp-save-btn ${this.state.changedItem ? "mp-save-btn--disabled" : ""}`} onClick={() => this.submit()}>
              <span className="material-symbols-outlined">add</span>
              {translate(ABSENCE_USER, "add_btn", me.language)}
            </button>
          </div>
        </div>

        {this.state.items.length > 0 && (
          <div className="mp-absence-history">
            <h3 className="mp-absence-title">{translate(ABSENCE_USER, "absence_history", me.language)}</h3>
            <div className="mp-absence-table">
              <div className="mp-absence-table-head">
                <span>{translate(ABSENCE_USER, "date_from", me.language)}</span>
                <span>{translate(ABSENCE_USER, "date_to", me.language)}</span>
                <span>{translate(ABSENCE_USER, "reason", me.language)}</span>
              </div>
              {this.state.items.map(i => (
                <div className="mp-absence-table-row" key={i.id}>
                  <span>{dateStart("", i)}</span>
                  <span>{dateEnd("", i)}</span>
                  <span>{i.reason}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Absence;
